import React, { useEffect, useState } from "react";
import { Form, Button, Icon, Image, Label } from "semantic-ui-react";
import { useFormik } from "formik";
import { initialValuesFive, validationSchemaFive } from "./StepFive.form";
import { TiptapEditor } from "../../../TiptapEditor/TiptapEditor";
import { VirtualScenes } from "../../../../api";
import { SceneFormFile } from "./SceneFormFile";
import { useAuth } from "../../../../hooks";
import "./SceneForm.scss";

const virtualSceneController = new VirtualScenes();

export function StepFive({
  formData,
  updateFormData,
  nextStep,
  prevStep,
  isUpdateMode,
  scene,
}) {
  const { accessToken } = useAuth();
  const [isFileModalOpen, setIsFileModalOpen] = useState(false);
  const [isPublic, setIsPublic] = useState(true);
  const [fileFieldName, setFileFieldName] = useState("");
  const [moduleData, setModuleData] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState({
    imagecompetencies: isUpdateMode
      ? moduleData?.ModFiveImagecompetencies
      : formData.ModFiveImagecompetencies || null,
  });

  // Cargar los datos del módulo si estamos en modo actualización
  useEffect(() => {
    async function fetchData() {
      if (isUpdateMode) {
        try {
          const data = await virtualSceneController.getVirtualScenesModeule(
            scene.refId,
            accessToken,
            "module_05",
          );
          setModuleData(data.moduleData);
        } catch (error) {
          console.error("Error fetching module data:", error);
        }
      }
    }
    fetchData();
  }, [isUpdateMode, accessToken, scene.refId]); // <-- CORREGIDO: Añadida dependencia 'scene.refId'

  const formik = useFormik({
    initialValues: isUpdateMode
      ? initialValuesFive(moduleData)
      : initialValuesFive(formData),
    validationSchema: validationSchemaFive(),
    validateOnChange: false,
    enableReinitialize: true, // <-- Esta línea ya actualiza el form cuando moduleData cambia.
    onSubmit: async (values) => {
      try {
        let _id = "";
        if (isUpdateMode) {
          _id = scene.refId;
        } else {
          _id = localStorage.getItem("idScene");
        }

        const modulePath = "module_05";
        const response = await virtualSceneController.createModuleAdd(
          modulePath,
          accessToken,
          _id,
          values,
        );
        console.log("response", response);
      } catch (error) {
        console.error("Error al enviar el formulario:", error);
      }

      updateFormData({ ...values });
      nextStep();
    },
  });

  // CORREGIDO: Este efecto ahora SOLO se encarga de los efectos secundarios que Formik no maneja.
  useEffect(() => {
    // La llamada a formik.setValues() se ha eliminado porque es redundante y peligrosa.
    // 'enableReinitialize: true' en useFormik ya se encarga de poblar el formulario.

    // Si existe imagecompetencies, obtenemos los datos del archivo
    if (moduleData?.ModFiveImagecompetencies) {
      async function fetchFileData() {
        try {
          const fileData = await virtualSceneController.getFileScene(
            moduleData.ModFiveImagecompetencies,
          );
          setUploadedFiles((prev) => ({
            ...prev,
            ModFiveImagecompetencies: fileData,
          }));
        } catch (error) {
          console.error(
            "Error al obtener los datos de ModFiveImagecompetencies:",
            error,
          );
        }
      }
      fetchFileData();
    }
    // CORREGIDO: La dependencia ahora es más específica, segura y no causa bucles.
  }, [moduleData?.ModFiveImagecompetencies]);

  const handleFileSubmit = (fileData) => {
    const { id } = fileData;
    // Para campos de un solo archivo
    setUploadedFiles((prev) => ({
      ...prev,
      [fileFieldName]: fileData,
    }));
    formik.setFieldValue(fileFieldName, id);
  };

  const handleRemoveFile = async (fieldName) => {
    if (uploadedFiles[fieldName]) {
      const fileId = uploadedFiles[fieldName]._id;
      try {
        await virtualSceneController.deleteImageRepo(accessToken, fileId);
        setUploadedFiles((prev) => ({
          ...prev,
          [fieldName]: null,
        }));
        formik.setFieldValue(fieldName, null);
      } catch (error) {
        console.error("Error al eliminar el archivo:", error);
      }
    }
  };

  // Funciones para agregar y eliminar competencias
  const addCompetencie = () => {
    formik.setFieldValue("ModFiveCompetencies", [
      ...formik.values.ModFiveCompetencies,
      { title: "", description: "" },
    ]);
  };

  const removeCompetencie = (index) => {
    const newCompetencies = formik.values.ModFiveCompetencies.filter(
      (item, i) => i !== index,
    );
    formik.setFieldValue("ModFiveCompetencies", newCompetencies);
  };

  return (
    <Form className="virtual-scene-form" onSubmit={formik.handleSubmit}>
      {/* Sección de Competencias Clave */}
      <div className="competencies-container">
        <label>Competencias Clave</label>
        {formik.values.ModFiveCompetencies.map((competency, index) => (
          <div key={index} className="competencies-item">
            <Form.Input
              name={`ModFiveCompetencies[${index}].title`}
              placeholder="Título de la categoría"
              onChange={formik.handleChange}
              value={competency.title}
              error={
                formik.errors.ModFiveCompetencies?.[index]?.title
                  ? { content: formik.errors.ModFiveCompetencies[index].title }
                  : null
              }
            />
            {/* Reemplazamos el Form.TextArea por el Editor Tiny */}
            <TiptapEditor
              content={competency.description}
              onChange={(content) =>
                formik.setFieldValue(
                  `ModFiveCompetencies[${index}].description`,
                  content,
                )
              }
            />
            {formik.errors.ModFiveCompetencies?.[index]?.description && (
              <Label basic color="red" pointing>
                {formik.errors.ModFiveCompetencies[index].description}
              </Label>
            )}
            <div className="container">
              <Button type="button" onClick={addCompetencie}>
                <Icon name="add" />
                Añadir Competencia
              </Button>
              <Button
                type="button"
                color="red"
                onClick={() => removeCompetencie(index)}
              >
                <Icon name="trash" />
                Eliminar competencia
              </Button>
            </div>
          </div>
        ))}
      </div>

      {/* File Upload for Image Competencies */}
      <div className="upload-field">
        <Button
          type="button"
          onClick={() => {
            setIsPublic(true);
            setFileFieldName("ModFiveImagecompetencies");
            setIsFileModalOpen(true);
          }}
        >
          Subir Imagen Competencias
        </Button>
        {uploadedFiles.ModFiveImagecompetencies && (
          <div className="image-preview">
            <Image
              src={uploadedFiles.ModFiveImagecompetencies.url}
              size="small"
              centered
            />
            <Icon
              name="close"
              onClick={() => handleRemoveFile("ModFiveImagecompetencies")}
            />
          </div>
        )}
        {formik.errors.ModFiveImagecompetencies && (
          <div className="error-message">
            {formik.errors.ModFiveImagecompetencies}
          </div>
        )}
      </div>

      {/* Modal for File Upload */}
      <SceneFormFile
        isOpen={isFileModalOpen}
        onClose={() => setIsFileModalOpen(false)}
        onSubmit={handleFileSubmit}
        isPublic={isPublic}
        idScene={formik.values.idScene}
      />

      <div className="formgroup">
        <Form.Group>
          <Button
            type="button"
            onClick={prevStep}
            color="orange"
            style={{ width: "33.3333%" }}
          >
            Anterior
          </Button>
          <Button
            type="submit"
            primary
            style={{
              width: isUpdateMode ? "33.3333%" : "66.6666%",
              marginLeft: isUpdateMode ? "auto" : "33.3333%",
            }}
            loading={formik.isSubmitting}
          >
            Subir
          </Button>
          {isUpdateMode && (
            <Button
              type="button"
              onClick={nextStep}
              color="green"
              style={{ width: "33.3333%" }}
            >
              Siguiente
            </Button>
          )}
        </Form.Group>
      </div>
    </Form>
  );
}
